/**
 * Shared measurement types — used by tools (DistanceTool / AreaTool / NoteTool)
 * and the side panel that lists / toggles them.
 *
 * The `id` is a UUID v4 minted client-side so the same id round-trips through
 * the backend (idempotent POST + WS echo dedupe).
 */

import type { Object3D } from 'three'
import type { AnnotationAuthor } from '../api/annotationsClient'

export type MeasurementKind = 'distance' | 'area' | 'note'

export interface Measurement {
  id: string
  kind: MeasurementKind
  /** Display label used in the panel (e.g. "Linie 1 — 12.34 m"). */
  label: string
  /** Visibility — flipping this flag toggles the rendered Three.js group. */
  visible: boolean
  /** Three.js sub-tree that draws this measurement. */
  group: Object3D
  color: number
  /** Author — undefined for own measurements until the create POST resolves. */
  createdBy?: AnnotationAuthor | null
  /** ISO timestamp from the server; undefined until persisted. */
  createdAt?: string
  /** True between local create and the server ack (or final failure). */
  pending?: boolean
}

export function nextId(): string {
  // crypto.randomUUID is available in all evergreen browsers + secure contexts.
  // localhost dev counts as secure; HTTPS in prod is required regardless.
  return crypto.randomUUID()
}
